import { SellerBadge } from "@/components/ui/seller-badge";
import { EarlyFounderBadge } from "@/components/ui/early-founder-badge";
import { RoleBadge } from "@/components/ui/role-badge";
import { cn } from "@/lib/utils";

export interface UserBadgeInfo {
  is_seller?: boolean | null;
  seller_verified?: boolean | null;
  is_early_founder?: boolean | null;
  roles?: string[];
}

interface UserBadgesProps {
  user: UserBadgeInfo;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function UserBadges({ user, size = "sm", className }: UserBadgesProps) {
  const hasAnyBadge =
    user.is_seller ||
    user.is_early_founder ||
    user.roles?.includes("admin") ||
    user.roles?.includes("moderator");

  if (!hasAnyBadge) return null;

  return (
    <span className={cn("inline-flex items-center gap-1 flex-wrap", className)}>
      {user.roles?.includes("admin") && <RoleBadge role="admin" size={size} />}
      {user.roles?.includes("moderator") && !user.roles?.includes("admin") && (
        <RoleBadge role="moderator" size={size} />
      )}
      {user.is_seller && (
        <SellerBadge verified={!!user.seller_verified} size={size} />
      )}
      {user.is_early_founder && <EarlyFounderBadge size={size} />}
    </span>
  );
}
